import { render, staticRenderFns } from "./ShareVideoTable.vue?vue&type=template&id=70238694&scoped=true&"
import script from "./ShareVideoTable.vue?vue&type=script&lang=js&"
export * from "./ShareVideoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70238694",
  null
  
)

export default component.exports